export default {
  en: {
    'UPlus AI 量化交易平台': 'UPlus AI Quantitative Trading Platform',
    '待支付': 'Pending payment',
    '登录后可查看，请先登录或注册': 'Available after login. Please log in or sign up',
    '合约 AI 交易（单向版）': 'Contract AI Trading (One-way)',
    '合约 AI 交易（闪电版）': 'Contract AI Trading (Lightning)',
    '机器人结算': 'Bot settlement',
    '链上充值': 'On-chain deposit',
    '期现 AI 交易': 'Spot-Futures AI Trading',
    '期现 AI 交易（闪电版）': 'Spot-Futures AI Trading (Lightning)',
    '期现 AI 交易（BTC 版）': 'Spot-Futures AI Trading (BTC)',
    '资产变动': 'Asset change',
    'UPlus 点卡': 'UPlus Points',
    '收益贡献': 'Earnings contribution',
    '收益贡献环形图': 'Earnings contribution donut chart',
    'LIVE 今日收益 (USDT)': 'LIVE Today earnings (USDT)',
    '策略记录': 'Strategy Records',
    '收益报表': 'Earnings Report',
    '全部交易所': 'All exchanges',
    '切换交易所': 'Switch exchange',
    '仅显示所选交易所的机器人与收益数据': 'Only show bots and earnings for the selected exchange',
    '已绑定 API · 可运行策略': 'API bound · Strategies available',
    '未绑定 API': 'API not bound',
    '匿名展示': 'Anonymous display',
    '每小时更新': 'Updated hourly',
    '覆盖开户、API、费用、风控全流程': 'Covers account opening, API, fees, and risk controls',
    '来自交易所实时委托': 'Live orders from the exchange',
    '按返回顺序展示': 'Shown in the returned order',
    '机器人使用中': 'bots in use',
    '已结算收益': 'Settled earnings',
    '教程步骤': 'Guide step',
    '近 30 日收益趋势': '30-day earnings trend',
    '按当前消耗预计可用约': 'Estimated availability at the current usage rate:',
    '链上数据已同步': 'On-chain data synced',
    '我的当前排名': 'My current rank',
    '周期收益': 'Period earnings',
    '一': 'Mon',
    '二': 'Tue',
    '三': 'Wed',
    '四': 'Thu',
    '五': 'Fri',
    '六': 'Sat',
    '日': 'Sun',
    '自动结算入账': 'automatically settled and credited',
    '已服务用户': 'Users served',
    '遇到问题？': 'Need help?',
    '联系在线客服': 'Contact support',
    '发送中…': 'Sending…',
    '登录中…': 'Logging in…',
    '注册中…': 'Signing up…',
    '登录成功，正在进入总览…': 'Login successful. Opening Overview…',
    '登录失败': 'Login failed',
    '登录失败，请稍后重试': 'Login failed. Please try again later',
    '两次输入的密码不一致': 'The two passwords do not match',
    '密码需至少 8 位，包含大小写字母、数字和特殊字符': 'Password must be at least 8 characters and include uppercase and lowercase letters, numbers, and symbols',
    '新密码需至少 8 位，包含大小写字母、数字和特殊字符': 'New password must be at least 8 characters and include uppercase and lowercase letters, numbers, and symbols',
    '密码重置失败，请稍后重试': 'Password reset failed. Please try again later',
    '强': 'Strong',
    '弱': 'Weak',
    '清空邮箱': 'Clear email',
    '清空账号': 'Clear account',
    '请输入 6 位数字验证码': 'Enter the 6-digit verification code',
    '请输入 6 位邮箱验证码': 'Enter the 6-digit email verification code',
    '请输入注册邮箱': 'Enter your registered email',
    '请先阅读并同意服务协议': 'Please read and agree to the Terms of Service first',
    '显示密码': 'Show password',
    '隐藏密码': 'Hide password',
    '验证码发送失败': 'Failed to send verification code',
    '验证码发送失败，请稍后重试': 'Failed to send verification code. Please try again later',
    '验证码已发送，10 分钟内有效': 'Verification code sent. It is valid for 10 minutes',
    '重置密码进度': 'Password reset progress',
    '注册成功，请登录你的账户': 'Registration successful. Please log in',
    '注册失败': 'Registration failed',
    '注册失败，请稍后重试': 'Registration failed. Please try again later',
    'UPlus 用户': 'UPlus User',
    '搜索策略 / 币种': 'Search strategy / coin',
    '通知': 'Notifications',
    '正在读取通知…': 'Loading notifications…',
    '暂无通知': 'No notifications',
    '主要导航': 'Main navigation',
    '页脚导航': 'Footer navigation',
    '点击查看通知详情': 'View notification details',
    '【图片】': '[Image]',
    '【视频】': '[Video]',
    '查看 ›': 'View ›',
    '点': 'points',
    '个': '',
    '关注': 'Attention',
    '良好': 'Healthy',
    '凌晨好': 'Good early morning',
    '早上好': 'Good morning',
    '下午好': 'Good afternoon',
    '晚上好': 'Good evening',
    '暂无策略数据': 'No strategy data',
    '正在加载': 'Loading',
    '刷新': 'Refresh',
    '正在加载策略…': 'Loading strategies…',
    '还没有运行中的策略': 'No active strategies yet',
    '正在处理': 'Processing',
    '点击关闭机器人': 'Click to turn off the bot',
    '点击关闭全部机器人': 'Click to turn off all bots',
    '点击展开': 'Click to expand',
    '共': 'Total',
    '个策略': 'strategies',
    'AI 智能量化策略': 'AI quantitative strategies',
    '合约策略与风险保护': 'Contract strategies and risk protection',
    '现货与合约组合策略': 'Spot and contract portfolio strategies',
    '现货自动交易策略': 'Automated spot trading strategies',
    '自动量化策略': 'Automated quantitative strategies',
    '点击启动机器人': 'Click to start the bot',
    '点击启动全部机器人': 'Click to start all bots',
    '达到最大持仓，点击查看处理方式': 'Maximum position reached. Click to view how to resolve it',
    '健康度': 'Health',
    '数据异常': 'Data anomaly',
    '推荐 · 热门': 'Recommended · Popular',
    '首推 · 热门': 'Featured · Popular',
    '主推 · 热门': 'Featured · Popular',
    '主推 · 稳健': 'Featured · Stable',
    '未知': 'Unknown',
    '状态未知': 'Unknown status',
    '已开启': 'Enabled',
    '暂无策略记录可导出': 'No strategy records to export',
    '展开查看详情': 'Expand to view details',
    '30 天': '30 days',
    '7 天': '7 days',
    '今年': 'This year',
    '实时': 'Real-time',
    '目标完成度': 'Target progress',
    '日期': 'Date',
    '月份': 'Month',
    '收益趋势时间范围': 'Earnings trend range',
    '收益趋势折线图': 'Earnings trend line chart',
    '收益颜色图例': 'Earnings color legend',
    '收益摘要': 'Earnings summary',
    '数值': 'Value',
    '项目': 'Item',
    '已结算收益 (USDT)': 'Settled earnings (USDT)',
    '返回收益': 'Back to earnings',
    '加仓提升排名': 'Increase position to improve ranking',
    '较上期': 'vs. previous period',
    '排名': 'Rank',
    '全部周期': 'All periods',
    '收益榜前三名': 'Top three earners',
    '收益榜周期': 'Ranking period',
    '运行策略': 'Active strategies',
    '暂无用户': 'No users',
    '周期收益 (USDT)': 'Period earnings (USDT)',
    '总榜': 'Overall ranking',
    '榜单基于已结算收益统计，用户信息匿名展示；仅展示前 20 名。': 'The ranking is based on settled earnings. User information is anonymized and only the top 20 are shown.',
    'USDT 总资产': 'Total assets (USDT)',
    '查看账单': 'View billing',
    '处理中': 'Processing',
    '点卡账户 (折算)': 'Points account (converted)',
    '今天': 'Today',
    '暂无资产分布数据': 'No asset distribution data',
    '资产数据尚未同步': 'Asset data not synced',
    '资产数据同步中': 'Syncing asset data',
    '正在同步订单…': 'Syncing orders…',
    '暂无订单数据': 'No order data',
    '搜索策略名称': 'Search strategy name',
    '账单月份': 'Billing month',
    '较上月': 'vs. last month',
    '期现套利': 'Spot-futures arbitrage',
    'BB 交易': 'BB Trading',
    'UB 交易': 'UB Trading',
    'UPlus-X 合约': 'UPlus-X Contracts',
    'UPlus-X 合约交易': 'UPlus-X Contract Trading',
    'Astra AI交易': 'Astra AI Trading',
    '全部通知已标记为已读': 'All notifications marked as read',
    '全部已读操作失败': 'Failed to mark all as read',
    '通知分类': 'Notification categories',
    '通知列表读取失败': 'Failed to load notifications',
    '通知详情读取失败': 'Failed to load notification details',
    '未读通知数量读取失败': 'Failed to load unread notification count',
    '在线工单': 'Online support ticket',
    '关闭在线工单': 'Close online support ticket',
    '关闭预览': 'Close preview',
    '开始留言': 'Start a message',
    '客服消息加载失败': 'Failed to load support messages',
    '留下你的邮箱，回复将直接发送到邮箱': 'Leave your email and replies will be sent directly to it',
    '你好，有什么问题请具体描述，我们会尽快为你处理。': 'Hello. Please describe your issue in detail and we will help as soon as possible.',
    '请输入你的邮箱地址': 'Enter your email address',
    '输入留言内容，回车发送...': 'Type a message and press Enter to send…',
    '图片大小不能超过12MB': 'Image size cannot exceed 12 MB',
    '消息发送失败': 'Failed to send message',
    '选择图片或拍照': 'Choose an image or take a photo',
    '更换': 'Replace',
    '移除图片': 'Remove image',
    '预览图片': 'Preview image',
    '查看原图': 'View original image',
    '在线客服 · 通常1小时内回复': 'Online support · Usually replies within 1 hour',
    '客服小U': 'Support U',
    '在线 · 已接入你的账户': 'Online · Connected to your account',
    '你好，我是客服小U': 'Hi, I’m Support U',
    '账户信息已同步，有什么可以帮你？': 'Your account is synced. How can I help?',
    '我的 API 状态': 'My API status',
    '提现多久到账': 'Withdrawal arrival time',
    '点卡怎么抵扣': 'How points are deducted',
    '策略亏损怎么办': 'What if a strategy loses money',
    '输入你的问题...': 'Type your question…',
    '客服不会索要密码、验证码或 API 密钥': 'Support will never ask for your password, verification code, or API key',
    '只支持 JPG、JPEG 或 PNG 图片': 'Only JPG, JPEG, or PNG images are supported',
    '工单消息内容': 'Support ticket message',
    '回复至': 'Reply to'
  },
  ko: {
    'UPlus AI 量化交易平台': 'UPlus AI 퀀트 트레이딩 플랫폼',
    '待支付': '결제 대기',
    '登录后可查看，请先登录或注册': '로그인 후 확인할 수 있습니다. 로그인하거나 가입하세요',
    '合约 AI 交易（单向版）': '계약 AI 거래 (단방향)',
    '合约 AI 交易（闪电版）': '계약 AI 거래 (라이트닝)',
    '机器人结算': '봇 정산',
    '链上充值': '온체인 충전',
    '期现 AI 交易': '현물-선물 AI 거래',
    '期现 AI 交易（闪电版）': '현물-선물 AI 거래 (라이트닝)',
    '期现 AI 交易（BTC 版）': '현물-선물 AI 거래 (BTC)',
    '资产变动': '자산 변동',
    'UPlus 点卡': 'UPlus 포인트',
    '收益贡献': '수익 기여도',
    '收益贡献环形图': '수익 기여도 도넛 차트',
    'LIVE 今日收益 (USDT)': 'LIVE 오늘 수익 (USDT)',
    '策略记录': '전략 기록',
    '收益报表': '수익 보고서',
    '全部交易所': '모든 거래소',
    '切换交易所': '거래소 전환',
    '仅显示所选交易所的机器人与收益数据': '선택한 거래소의 봇과 수익 데이터만 표시합니다',
    '已绑定 API · 可运行策略': 'API 연동됨 · 전략 실행 가능',
    '未绑定 API': 'API 연동 안 됨',
    '匿名展示': '익명 표시',
    '每小时更新': '매시간 업데이트',
    '覆盖开户、API、费用、风控全流程': '계정 개설, API, 수수료 및 위험 관리 전 과정 안내',
    '来自交易所实时委托': '거래소 실시간 주문',
    '按返回顺序展示': '반환 순서대로 표시',
    '机器人使用中': '개 봇 사용 중',
    '已结算收益': '정산 수익',
    '教程步骤': '가이드 단계',
    '近 30 日收益趋势': '최근 30일 수익 추이',
    '按当前消耗预计可用约': '현재 사용량 기준 예상 이용 기간:',
    '链上数据已同步': '온체인 데이터 동기화됨',
    '我的当前排名': '내 현재 순위',
    '周期收益': '기간 수익',
    '一': '월',
    '二': '화',
    '三': '수',
    '四': '목',
    '五': '금',
    '六': '토',
    '日': '일',
    '自动结算入账': '자동 정산 및 입금',
    '已服务用户': '서비스 이용자',
    '遇到问题？': '도움이 필요하신가요?',
    '联系在线客服': '고객센터 문의',
    '发送中…': '전송 중…',
    '登录中…': '로그인 중…',
    '注册中…': '가입 중…',
    '登录成功，正在进入总览…': '로그인되었습니다. 개요를 여는 중…',
    '登录失败': '로그인 실패',
    '登录失败，请稍后重试': '로그인에 실패했습니다. 잠시 후 다시 시도하세요',
    '两次输入的密码不一致': '두 비밀번호가 일치하지 않습니다',
    '密码需至少 8 位，包含大小写字母、数字和特殊字符': '비밀번호는 8자 이상이며 대문자, 소문자, 숫자와 특수문자를 포함해야 합니다',
    '新密码需至少 8 位，包含大小写字母、数字和特殊字符': '새 비밀번호는 8자 이상이며 대문자, 소문자, 숫자와 특수문자를 포함해야 합니다',
    '密码重置失败，请稍后重试': '비밀번호 재설정에 실패했습니다. 잠시 후 다시 시도하세요',
    '强': '강함',
    '弱': '약함',
    '清空邮箱': '이메일 지우기',
    '清空账号': '계정 지우기',
    '请输入 6 位数字验证码': '6자리 인증 코드를 입력하세요',
    '请输入 6 位邮箱验证码': '이메일로 받은 6자리 인증 코드를 입력하세요',
    '请输入注册邮箱': '가입 이메일을 입력하세요',
    '请先阅读并同意服务协议': '먼저 서비스 약관을 읽고 동의하세요',
    '显示密码': '비밀번호 표시',
    '隐藏密码': '비밀번호 숨기기',
    '验证码发送失败': '인증 코드 전송 실패',
    '验证码发送失败，请稍后重试': '인증 코드 전송에 실패했습니다. 잠시 후 다시 시도하세요',
    '验证码已发送，10 分钟内有效': '인증 코드가 전송되었으며 10분 동안 유효합니다',
    '重置密码进度': '비밀번호 재설정 진행',
    '注册成功，请登录你的账户': '가입되었습니다. 계정에 로그인하세요',
    '注册失败': '가입 실패',
    '注册失败，请稍后重试': '가입에 실패했습니다. 잠시 후 다시 시도하세요',
    'UPlus 用户': 'UPlus 사용자',
    '搜索策略 / 币种': '전략 / 코인 검색',
    '通知': '알림',
    '正在读取通知…': '알림을 불러오는 중…',
    '暂无通知': '알림 없음',
    '主要导航': '주요 탐색',
    '页脚导航': '바닥글 탐색',
    '点击查看通知详情': '알림 상세 보기',
    '【图片】': '[이미지]',
    '【视频】': '[동영상]',
    '查看 ›': '보기 ›',
    '点': '포인트',
    '个': '',
    '关注': '관심 필요',
    '良好': '양호',
    '凌晨好': '좋은 새벽입니다',
    '早上好': '좋은 아침입니다',
    '下午好': '좋은 오후입니다',
    '晚上好': '좋은 저녁입니다',
    '暂无策略数据': '전략 데이터 없음',
    '正在加载': '로딩 중',
    '刷新': '새로고침',
    '正在加载策略…': '전략 로딩 중…',
    '还没有运行中的策略': '실행 중인 전략이 없습니다',
    '正在处理': '처리 중',
    '点击关闭机器人': '클릭하여 봇 끄기',
    '点击关闭全部机器人': '클릭하여 모든 봇 끄기',
    '点击展开': '클릭하여 펼치기',
    '共': '총',
    '个策略': '개 전략',
    'AI 智能量化策略': 'AI 스마트 퀀트 전략',
    '合约策略与风险保护': '계약 전략 및 리스크 보호',
    '现货与合约组合策略': '현물·계약 포트폴리오 전략',
    '现货自动交易策略': '현물 자동 거래 전략',
    '自动量化策略': '자동 퀀트 전략',
    '点击启动机器人': '클릭하여 봇 시작',
    '点击启动全部机器人': '클릭하여 모든 봇 시작',
    '达到最大持仓，点击查看处理方式': '최대 포지션에 도달했습니다. 해결 방법을 확인하세요',
    '健康度': '건전성',
    '数据异常': '데이터 이상',
    '推荐 · 热门': '추천 · 인기',
    '首推 · 热门': '첫 추천 · 인기',
    '主推 · 热门': '주요 추천 · 인기',
    '主推 · 稳健': '주요 추천 · 안정형',
    '未知': '알 수 없음',
    '状态未知': '상태 알 수 없음',
    '已开启': '활성화됨',
    '暂无策略记录可导出': '내보낼 전략 기록이 없습니다',
    '展开查看详情': '상세 내용 펼치기',
    '30 天': '30일',
    '7 天': '7일',
    '今年': '올해',
    '实时': '실시간',
    '目标完成度': '목표 달성률',
    '日期': '날짜',
    '月份': '월',
    '收益趋势时间范围': '수익 추세 기간',
    '收益趋势折线图': '수익 추세 선 그래프',
    '收益颜色图例': '수익 색상 범례',
    '收益摘要': '수익 요약',
    '数值': '값',
    '项目': '항목',
    '已结算收益 (USDT)': '정산 수익 (USDT)',
    '返回收益': '수익으로 돌아가기',
    '加仓提升排名': '포지션을 늘려 순위 높이기',
    '较上期': '이전 기간 대비',
    '排名': '순위',
    '全部周期': '전체 기간',
    '收益榜前三名': '수익 상위 3명',
    '收益榜周期': '순위 기간',
    '运行策略': '실행 전략',
    '暂无用户': '사용자 없음',
    '周期收益 (USDT)': '기간 수익 (USDT)',
    '总榜': '전체 순위',
    '榜单基于已结算收益统计，用户信息匿名展示；仅展示前 20 名。': '순위는 정산 수익을 기준으로 하며 사용자 정보는 익명으로 표시됩니다. 상위 20명만 표시됩니다.',
    'USDT 总资产': 'USDT 총자산',
    '查看账单': '청구 내역 보기',
    '处理中': '처리 중',
    '点卡账户 (折算)': '포인트 계정 (환산)',
    '今天': '오늘',
    '暂无资产分布数据': '자산 분포 데이터 없음',
    '资产数据尚未同步': '자산 데이터가 아직 동기화되지 않았습니다',
    '资产数据同步中': '자산 데이터 동기화 중',
    '正在同步订单…': '주문 동기화 중…',
    '暂无订单数据': '주문 데이터 없음',
    '搜索策略名称': '전략 이름 검색',
    '账单月份': '청구 월',
    '较上月': '지난달 대비',
    '期现套利': '현물-선물 차익거래',
    'BB 交易': 'BB 거래',
    'UB 交易': 'UB 거래',
    'UPlus-X 合约': 'UPlus-X 계약',
    'UPlus-X 合约交易': 'UPlus-X 계약 거래',
    'Astra AI交易': 'Astra AI 거래',
    '全部通知已标记为已读': '모든 알림을 읽음으로 표시했습니다',
    '全部已读操作失败': '모두 읽음 처리에 실패했습니다',
    '通知分类': '알림 분류',
    '通知列表读取失败': '알림 목록을 불러오지 못했습니다',
    '通知详情读取失败': '알림 상세를 불러오지 못했습니다',
    '未读通知数量读取失败': '읽지 않은 알림 수를 불러오지 못했습니다',
    '在线工单': '온라인 지원 티켓',
    '关闭在线工单': '온라인 지원 티켓 닫기',
    '关闭预览': '미리보기 닫기',
    '开始留言': '메시지 시작',
    '客服消息加载失败': '고객 지원 메시지를 불러오지 못했습니다',
    '留下你的邮箱，回复将直接发送到邮箱': '이메일을 남기면 답변을 이메일로 보내드립니다',
    '你好，有什么问题请具体描述，我们会尽快为你处理。': '안녕하세요. 문제를 자세히 설명해 주시면 최대한 빨리 도와드리겠습니다.',
    '请输入你的邮箱地址': '이메일 주소를 입력하세요',
    '输入留言内容，回车发送...': '메시지를 입력하고 Enter를 눌러 전송하세요…',
    '图片大小不能超过12MB': '이미지는 12MB를 초과할 수 없습니다',
    '消息发送失败': '메시지 전송 실패',
    '选择图片或拍照': '이미지 선택 또는 촬영',
    '更换': '교체',
    '移除图片': '이미지 제거',
    '预览图片': '이미지 미리보기',
    '查看原图': '원본 이미지 보기',
    '在线客服 · 通常1小时内回复': '온라인 고객 지원 · 보통 1시간 이내 답변',
    '客服小U': '고객지원 U',
    '在线 · 已接入你的账户': '온라인 · 계정 연결됨',
    '你好，我是客服小U': '안녕하세요, 고객지원 U입니다',
    '账户信息已同步，有什么可以帮你？': '계정 정보가 동기화되었습니다. 무엇을 도와드릴까요?',
    '我的 API 状态': '내 API 상태',
    '提现多久到账': '출금 소요 시간',
    '点卡怎么抵扣': '포인트 차감 방법',
    '策略亏损怎么办': '전략 손실 대처 방법',
    '输入你的问题...': '질문을 입력하세요…',
    '客服不会索要密码、验证码或 API 密钥': '고객지원은 비밀번호, 인증 코드 또는 API 키를 요구하지 않습니다',
    '只支持 JPG、JPEG 或 PNG 图片': 'JPG, JPEG 또는 PNG 이미지만 지원합니다',
    '工单消息内容': '지원 티켓 메시지',
    '回复至': '답변 이메일'
  }
}
